const states = [
  { id:1, state_name:"Tamil Nadu"     },
  { id:2, state_name:"Karnataka"      },
  { id:3, state_name:"Kerala"         },
  { id:4, state_name:"Andhra Pradesh" },
  { id:5, state_name:"Telangana"      },
  { id:6, state_name:"Maharashtra"    },
];
export default states;